import { createFileRoute } from "@tanstack/react-router";

import { parseClientSearch } from "@/features/accounts";
import { ClientPage } from "@/features/accounts/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/clients/$userId")({
  validateSearch: strictSearch(parseClientSearch),
  component: Client,
});

function Client() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Keyed by the person: going from one client to another starts the page anew.
  return (
    <ClientPage
      key={userId}
      userId={userId}
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
